// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35eCq","col":"styles_col__4b1W8"};